import React from "react";

import { doNothing, getClosureFor } from "@kazoohr/helpers";

import { Checkbox } from "../Checkbox";
import { IconButton } from "../IconButton";
import { UtilityText } from "../UtilityText";

import styles from "./DataTable.scss";
import { TableColumn, TableDataType } from "./types";

interface MobileTableRowProps {
  showCheckboxes?: boolean;
  columns?: TableColumn[];
  dataItem: TableDataType;
  selectedRowIds?: any[];
  onToggleSelectOne?: (id: any) => void;
}

interface ToggleContentButtonProps {
  toggle: boolean;
  onClick: () => void;
}

function ToggleContentButton({
  toggle,
  onClick,
}: ToggleContentButtonProps): React.ReactElement {
  return (
    <IconButton
      icon={toggle ? "caret_up" : "caret_dn"}
      size="small"
      iconSize={8}
      onClick={onClick}
      className={styles["toggle-mobile-content-button"]}
      data-testid="toggle-data-button"
    />
  );
}

export function MobileTableRow({
  showCheckboxes = false,
  columns = [],
  dataItem,
  selectedRowIds = [],
  onToggleSelectOne = doNothing,
}: MobileTableRowProps): React.ReactElement {
  const [toggle, setToggle] = React.useState<boolean>(false);

  const showAllFields = columns.every(
    (column) => !column.hideOnResponsivePreview
  );

  const getColumnsToShow = (): TableColumn[] => {
    const rows = columns.filter((column) => !column.hideOnResponsive);
    return toggle
      ? rows
      : rows.filter((column) => !column.hideOnResponsivePreview);
  };

  return (
    <div className={styles["mobile-table-row"]}>
      {showCheckboxes && (
        <div className={styles["mobile-checkbox"]}>
          <Checkbox
            id={dataItem.id}
            checked={selectedRowIds.includes(dataItem.id)}
            onChange={getClosureFor(onToggleSelectOne, dataItem.id)}
            data-testid="mobile-item-checkbox"
          />
        </div>
      )}
      {!showAllFields && (
        <ToggleContentButton
          toggle={toggle}
          onClick={getClosureFor(setToggle, !toggle)}
        />
      )}
      <div className={styles["mobile-table-content"]}>
        {getColumnsToShow().map((column, index) => (
          <div key={`${index}`} className={styles["pair-data"]}>
            <div className={styles["text-with-action-button"]}>
              <UtilityText size="small">
                {typeof column.header === "function"
                  ? column.header()
                  : column.header}
              </UtilityText>
            </div>
            <div className={styles.data}>{column.renderCell(dataItem)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
